import { useMemo } from 'react';
import {
	EPIC_PARENT_HIERARCHY_TYPE,
	CHILD_HIERARCHY_TYPE,
} from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import type { IssueType } from '../../../../../../model/issue-type/types.tsx';

export const useIssueTypes = (issueTypes: IssueType[] | undefined): IssueType[] | undefined =>
	useMemo(() => {
		if (!issueTypes || !issueTypes.length) {
			return issueTypes;
		}

		return issueTypes.filter(
			(issueType) =>
				issueType.typeHierarchyLevel !== EPIC_PARENT_HIERARCHY_TYPE &&
				issueType.typeHierarchyLevel !== CHILD_HIERARCHY_TYPE,
		);
	}, [issueTypes]);
